import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import Footer from "./footer";
import ProductLogoShowcase from "./product-logo-showcase";
import "../styles/self-hosted-fonts.css";
import "./layout.css";
import "../styles/index.scss";
import "../styles/output.css";
import "../styles/custom.scss";

import { adRefCity } from "../helpers/adRefTracking";
import { businessNode, jsonLdGraph, profileUrls, serializeJsonLd, websiteNode } from "../helpers/schema";
import Navbar from "./Navbar";

// `schema`: extra JSON-LD nodes for this page (src/helpers/schema.js). They go
// into the page's one @graph after the business node every page carries.
const Layout = ({ children, pageProps, footerLogoShowcase, isHomePage, schema, headerTransparent, headerShadow }) => {
  // pageProps is optional — src/pages/thanks.js renders <Layout> without it. Fall
  // back to window.location so a first-time visitor landing straight on such a page
  // doesn't take a TypeError here and lose hydration for the whole page.
  if (typeof window !== "undefined" && window.localStorage && !window.localStorage.getItem("landingURL")) {
    try {
      const landingHref =
        (pageProps && pageProps.location && pageProps.location.href) || window.location.href;
      window.localStorage.setItem("landingURL", landingHref);
      window.localStorage.setItem("landingDate", new Date());
    } catch (e) {
      /* storage unavailable — attribution is best-effort, never fatal */
    }
  }
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              companyInfo {
                phone
                email
                addressLine1
                addressLine2
                city
                state
                zip
                license
              }
              social {
                guildquality
                facebook
                yelp
                instagram
                youtube
                google
                porch
                houzz
              }
            }
          }
          allContentfulNavigation(filter: { name: { eq: "Main Navigation" } }) {
            edges {
              node {
                id
                name
                menuItems {
                  id
                  name
                  title
                  url
                  openInNewWindow
                  submenu {
                    id
                    name
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                    }
                  }
                }
                campaign
              }
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Navbar
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            pageProps={pageProps}
            headerTransparent={headerTransparent}
            shadow={headerShadow}
          />

          {/* <Header
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            mainNavigation={
              data.allContentfulNavigation.edges.filter(
                ({ node: { campaign } }) =>
                  campaign.length > 0 ? campaign[0] === 'default' : false
              )[0].node.menuItems
            }
            menus={data.allContentfulNavigation.edges}
            pageProps={pageProps}
          /> */}

          <div className="layout-container">{children}</div>
          {footerLogoShowcase !== false ? (
            <ProductLogoShowcase footerLogoShowcase={footerLogoShowcase} />
          ) : null}
          <Footer isHomePage={isHomePage} />
          {/* Promotion modal removed from the render tree: its open trigger has
              been commented out for years, so it only shipped dead JS
              (reactjs-popup + js-cookie) on every page. Restore the import and
              element together if the promo ever comes back. */}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: serializeJsonLd(
                jsonLdGraph([
                  businessNode({
                    email: data.site.siteMetadata.companyInfo.email,
                    sameAs: profileUrls(data.site.siteMetadata.social),
                  }),
                  isHomePage ? websiteNode() : null,
                  ...(schema || []),
                ])
              ),
            }}
          />
        </>
      )}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

//classes for tailwind to include when doing purge
// pr-2
